"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortRow = exports.getFeatureRow = exports.getBedRow = exports.getSizeRow = exports.getPriceRow = exports.getDistrictRow = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var sortOptionToSortInfo_1 = require("@/transformers/sortOptionToSortInfo");
var Area_1 = require("@/pages/search/states/Area");
var removeExistedInFullset = function (exist, full) {
    var final = [];
    exist.map(function (it) {
        if (full.indexOf(it) === -1) {
            final.push(it);
        }
    });
    return final;
};
var hasCompleteSet = function (full, current) {
    var existed = [];
    current.map(function (it) {
        if (full.indexOf(it) >= 0) {
            existed.push(it);
        }
    });
    if (full.length === existed.length)
        return true;
    return false;
};
exports.getDistrictRow = function (area, currentDistricts, districts, andMore) {
    var finalArea = JSON.parse(JSON.stringify(area));
    var finalDistricts = JSON.parse(JSON.stringify(currentDistricts));
    var parsedDistricts = districts.map(function (it) { return (__assign(__assign({}, it), { area: Area_1.parentToArea(it.parent) })); });
    area.map(function (areaId) {
        var fullSet = parsedDistricts.filter(function (it) { return it.area === Area_1.toArea(areaId); }).map(function (it) { return it.id; });
        var isCompleted = hasCompleteSet(fullSet, currentDistricts);
        if (isCompleted) {
            finalDistricts = removeExistedInFullset(currentDistricts, fullSet);
        }
        else {
            finalArea.splice(finalArea.indexOf(areaId), 1);
        }
    });
    var finals = __spreadArrays(finalArea.map(function (it) { return it * 1000; }), finalDistricts);
    var names = parsedDistricts.filter(function (it) { return finals.indexOf(it.id) >= 0; }).map(function (it) { return it.name; });
    return names.length > 4 ? names.slice(0, 4).join(', ') + " " + andMore : names.join(', ');
};
exports.getPriceRow = function (min, max, type, currency, map, above, below) {
    var symbol = map.filter(function (it) { return it.key === currency; })[0].symbol;
    var from = format_1.default.currency(type === SfilterTypeGroup_1.SfilterType.BUY ? min * 10000 : min, symbol);
    var to = format_1.default.currency(type === SfilterTypeGroup_1.SfilterType.BUY ? max * 10000 : max, symbol);
    if (max === 0 || max === -1) {
        return from + " " + above;
    }
    if (min === 0) {
        return below + " " + to;
    }
    return from + " - " + to + " ";
};
exports.getSizeRow = function (min, max, ft, type, above, below) {
    var from = format_1.default.comma(min);
    var to = format_1.default.comma(max);
    if (min === 0) {
        return below + " " + to + " " + ft + " " + type;
    }
    if (max === 0 || max === -1) {
        return above + " " + from + " " + ft + " " + type;
    }
    return from + " - " + to + " " + ft + " " + type + " ";
};
exports.getBedRow = function (min, max, studio) {
    if (max === 20)
        return min + " +";
    if (!min && !max)
        return studio;
};
exports.getFeatureRow = function (hasMaid, hasParking, hasOutdoor, maid, park, outdoor) {
    var features = [];
    if (hasMaid)
        features.push(maid);
    if (hasParking)
        features.push(park);
    if (hasOutdoor)
        features.push(outdoor);
    return features.join(', ');
};
exports.getSortRow = function (orderBy, sortBy, options) {
    var newOrderBy = orderBy || 'desc';
    var newSortBy = sortBy || 'qualityscore';
    var index = sortOptionToSortInfo_1.sortInfoToSortOptionValue(newSortBy, newOrderBy);
    return options.find(function (it) { return it.value === index; }).name;
};
